module.exports = __webpack_public_path__ + "static/media/Industrial-3.d3c03994.jpg";